var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"product-page-header"},[_c('div',{staticClass:"left"},[_vm._t("left",function(){return [_c('h3',{staticClass:"header-title text-primary clearfix"},[_c('span',{staticClass:"title-icon"},[_c('svg-icon',{attrs:{"iconClass":_vm.$route.meta.iconSvg}})],1),_vm._v(" "+_vm._s(_vm.$route.meta.title)+" ")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }